import React from "react";
import CircularProgress from '@mui/material/CircularProgress';

const Spinner = () => { 

    return (  
    <div>
        <CircularProgress color="success" />
    </div>
    );

    }


export default Spinner;